import * as Yup from 'yup'

export const US_ZIP_FIVE_REGEX = /^\d{5}$/
export const US_ZIP_FIVE_OR_NINE_REGEX = /^\d{5}(-\d{4})?$/
export const US_ZIP_PLUS_FOUR_REGEX = /^\d{5}-\d{4}$/
export const GENERIC_POSTAL_CODE_REGEX = /^[A-Za-z0-9\s-]+$/

export const ZIP_PLUS_FOUR_REQUIRED_MESSAGE =
  'ZIP+4 is required — USPS could not confirm this address. Use the 12345-6789 format.'

export interface BuildDeliveryDetailsSchemaOptions {
  administrativeDivisionLabel: string
  enforceZipPlus4?: boolean
}

const ZIP_SOURCE_CUSTOM = 'custom'

export function buildDeliveryDetailsSchema({
  administrativeDivisionLabel,
  enforceZipPlus4 = false
}: BuildDeliveryDetailsSchemaOptions) {
  const usPostalCodeRule = enforceZipPlus4
    ? Yup.string()
        .required('Postal/Zip code is required')
        .matches(US_ZIP_PLUS_FOUR_REGEX, ZIP_PLUS_FOUR_REQUIRED_MESSAGE)
    : Yup.string()
        .required('Postal/Zip code is required')
        .matches(US_ZIP_FIVE_OR_NINE_REGEX, 'Enter a 5-digit ZIP or ZIP+4 (12345 or 12345-6789)')

  return Yup.object({
    streetAddress: Yup.string()
      .required('Street address is required')
      .min(5, 'Street address must be at least 5 characters')
      .max(100, 'Street address must be less than 100 characters'),
    country: Yup.string().required('Country is required'),
    administrativeDivision: Yup.string().required(`${administrativeDivisionLabel} is required`),
    city: Yup.string().required('City is required'),
    postalCode: Yup.string().when('country', {
      is: 'US',
      then: () => usPostalCodeRule,
      otherwise: (schema) =>
        schema
          .required('Postal/Zip code is required')
          .matches(GENERIC_POSTAL_CODE_REGEX, 'Invalid postal/zip code format')
    }),
    zipSource: Yup.string().oneOf(['airport', 'custom']).required(),
    customPostalCode: Yup.string().when('zipSource', {
      is: ZIP_SOURCE_CUSTOM,
      then: () =>
        enforceZipPlus4
          ? Yup.string()
              .required('ZIP code is required')
              .matches(US_ZIP_PLUS_FOUR_REGEX, ZIP_PLUS_FOUR_REQUIRED_MESSAGE)
          : Yup.string()
              .required('ZIP code is required')
              .matches(US_ZIP_FIVE_OR_NINE_REGEX, 'Enter a valid 5-digit ZIP or ZIP+4')
    })
  })
}
